import { z } from 'zod';
export const SearchSchema = z.object({
  freeText: z.string().optional(),
  isOnlyCustomApp: z.boolean().optional(),
  invalid: z.boolean().optional(),
  operationTaskInstanceId: z.string().optional(),
  groupBy: z.enum(['app', 'person']).optional(),
  pageIndex: z.number().optional(),
  pageSize: z.number().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional()
});
export type SearchParams = z.infer<typeof SearchSchema>;